<template>
  <a-button type="link" size="small" class="btn" @click="() => visible = true" :title="title">{{ title }}</a-button>
  <a-modal :width="400" v-model:open="visible" @ok="submit">
    <a-space direction="vertical" style="width: 100%; margin-top: 30px;">
      <a-input-search v-model:value="searchKey" placeholder="搜索..." allow-clear style="width: 100%;" />
      <div class="select-box">
        <a-tree :auto-expand-parent="true" v-model:checkedKeys="selectedValue" :defaultExpandAll="true"
          :tree-data="tree" checkable v-if="searchKey.length === 0">
        </a-tree>
        <template v-else>
          <a-list size="small" :data-source="searchGoods" v-if="searchGoods.length > 0">
            <template #renderItem="{ item }">
              <a-list-item>
                <a-checkbox :checked="selectedValue.indexOf(item.id) > -1" @click="() => clickGood(item)">{{ item.name
                  }}</a-checkbox>
              </a-list-item>
            </template>
          </a-list>
          <a-empty v-else />
        </template>
      </div>
      <div class="selected">
        <a-tag color="cyan" v-for="item in showGoods" :key="item.id">
          <template #icon>
            <huasky-icon icon="CloseOutlined" @click="() => removeGood(item)" />
          </template>
          {{ item.name }}
        </a-tag>
      </div>
    </a-space>
  </a-modal>
</template>
<script setup lang="ts">
import { getSimpleGood } from '@src/scripts/api/good'
import { getMenuTree } from '@src/scripts/huasky'
import { watch } from 'vue'
import { computed, ref } from 'vue'
import { onMounted } from 'vue'


const props = withDefaults(defineProps<{
  value?: string[]
}>(), {
  value: () => []
})
const emits = defineEmits(['update:value'])



const searchKey = ref('')
const menus = ref<SimpleGood[]>([])
const selectedMenu = computed(() => menus.value.filter(a => props.value.indexOf(a.name) > -1))
const visible = ref(false)
const tree = ref<TreeData[]>([])
const selectedValue = ref<string[]>([])
// 显示已经选择的商品
const showGoods = computed(() => menus.value.filter(a => selectedValue.value.indexOf(a.id) > -1))
// 搜索到的商品
const searchGoods = computed(() => menus.value.filter(a => a.name.filter(searchKey.value)))

/**
 * 监听显示变化，变化时，赋值选项值
 */
watch(() => visible.value, () => {
  const names = props.value ?? []
  const ids = menus.value.filter(a => names.indexOf(a.name) > -1).map(a => a.id)
  selectedValue.value = ids
  searchKey.value = ''
})

const title = computed(() => {
  if (!props.value || props.value.length === 0) return '选择商品'
  return props.value.join(',')
})

// const source = computed(() => {
//   const obj = $util.clone(tree.value)
//   obj.forEach(node => {
//     if (!node.children || node.children.length === 0) return
//     node.children = node.children.filter(a => a.title.filter(searchKey.value))
//   })
//   return obj
// })

// 页面加载后，读取菜单
onMounted(async () => {
  const { data } = await getSimpleGood()
  menus.value = data
  tree.value = await getMenuTree(null, data)
})

// 移除已选商品
const removeGood = (good: SimpleGood) => {
  selectedValue.value.remove(good.id)
  const parentId = selectedValue.value.find(a => a.indexOf(good.category) > -1)
  if (!parentId) return
  selectedValue.value.remove(parentId)
}

// 点击商品checkbox
const clickGood = (good: SimpleGood) => {
  const exist = selectedValue.value.indexOf(good.id) > -1
  if (!exist) {
    selectedValue.value.push(good.id)
    return
  }
  removeGood(good)
}

const submit = () => {
  const goods = selectedValue.value.map(id => {
    const menu = menus.value.first(a => a.id == id)
    return menu.name
  })
  emits('update:value', goods)
  visible.value = false
}

</script>
<style scoped lang="scss">
.exist {
  color: red;
}

.select-box {
  height: calc(100vh - 600px);
  overflow: auto;
  min-height: 400px;
}

.selected {
  border: 1px solid #ccc;
  height: 150px;
  border-radius: 5px;
  overflow-y: auto;
  padding: 10px;
  margin-top: 10px;

  .ant-tag {
    margin-bottom: 5px;

    .anticon {
      cursor: pointer;
    }
  }
}

.btn {
  max-width: 300px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>